import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Alert from "./Alert";
import UserContext from "../context/UserContext";
import { apiURL } from "../api";

export default function SignIn() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const { setUserData } = useContext(UserContext);

  const [alertMessage, setAlertMessage] = useState("");
  const [alertClass, setAlertClass] = useState("d-none");

  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ credentials: [username, password] }),
    };

    fetch(apiURL + "/admin/signin", requestOptions)
      .then((response) => response.json())
      .then((response) => {
        if (response.error) {
          throw new Error(response.error.message);
        } else {
            setUserData(response.result);
            navigate("/");
        }
      })
      .catch((error) => {
        console.log(error.message);
        setAlertMessage(error.message);
        setAlertClass("alert-danger");
      });
  };

  return (
    <div
      className="container p-4 mt-5 bg-light rounded-4"
      style={{ width: "360px" }}
    >
      <div className="d-flex justify-content-center">
        <h2>Sing In</h2>
      </div>
      <form onSubmit={handleSubmit}>
      <div className="form-floating my-3">
        <input
          type="text"
          className="form-control"
          id="signInUsername"
          placeholder="Username"
          onChange={(event) => {
            setUsername(event.target.value);
            setAlertMessage("");
            setAlertClass("d-none");
          }}
        />
        <label htmlFor="signInUsername">Username</label>
      </div>
      <div className="form-floating my-3">
        <input
          type="password"
          className="form-control"
          id="signInPassword"
          placeholder="Password"
          onChange={(event) => {
            setPassword(event.target.value);
            setAlertMessage("");
            setAlertClass("d-none");
          }}
        />
        <label htmlFor="signInPassword">Password</label>
      </div>
      <Alert message={alertMessage} className={alertClass} />
      <div className="d-grid">
        <input
          className="btn btn-lg btn-primary"
          type="submit"
          value="Sign In"
        />
      </div>
      </form>
    </div>
  );
}
